import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AuthService } from '../Services/auth.service';

export const loggedInGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.initializeAuth().pipe(
    map((is_authenticated) => {
      if (is_authenticated) {
        return true;
      }

      authService.setReturnUrl(state.url);
      return router.createUrlTree(['/auth/login']);
    })
  );
};
